import React, { useState, useEffect } from "react";
import TheHeader from "../common/TheHeader";
import TheFooter from "../common/footer/TheFooter";
import { Outlet } from "react-router";
import ExitIntentModal from "../common/modals/ExitIntentModal";
import FloatingCTA from "../floating-elements/FloatingCTA";
import FloatingWhatsApp from "../floating-elements/FloatingWhatsApp";
import WelcomeModal from "../common/modals/WelcomeModal";
import WhatsAppFloatButton from "../contact/WhatsAppFloatButton";

const RootLayout = () => {
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    // Check if user has already seen the modal
    const hasSeenModal = localStorage.getItem('hasSeenWelcomeModal');

    if (!hasSeenModal) {
      // Show modal after 3 seconds
      const timer = setTimeout(() => {
        setShowWelcomeModal(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseWelcomeModal = () => {
    setShowWelcomeModal(false);
    localStorage.setItem('hasSeenWelcomeModal', 'true');
  };

  const handleWelcomeSubmit = () => {
    localStorage.setItem('hasSeenWelcomeModal', 'true');
  };

  return (
    <div className="min-h-screen bg-white">
      <TheHeader />
      <main>
        <Outlet />
      </main>
      <TheFooter />
      <ExitIntentModal />
      {/* <SocialProofPopup /> */}
      <FloatingCTA />
      <WhatsAppFloatButton />
      <FloatingWhatsApp />
      {/* <FloatingNotifications /> */}
      <WelcomeModal
        show={showWelcomeModal}
        onClose={handleCloseWelcomeModal}
        onSubmit={handleWelcomeSubmit}
      />
    </div>
  );
};

export default RootLayout;


